// src/constants/colors.js

const Colors = {
  sidebar_blue: '#3f7dda',
  bg_blue: '#3f7dda',
  bg_green: '#0cba91',
  bg_dark_pink: '#ff6c6c',
  bg_yellow: '#fbbd4a',
  bg_orange: '#e89464',
  bg_gray: '#b0bac9',
  bg_success: '#0cba91',
  bg_damage: '#ff6c6c',
  bg_semi_damage: '#fbbd4a',
  bg_not_found: '#e89464',
  background: '#ffffff',
  text: '#212529',
  exportbBtn: '#adb5bd',
};

export default Colors;


export const MecordColors = {
  DefaultText: "#878899",
  NormalText: "#000000ff",
  ActiveText: "#AB2123",
  ActiveBackground: "#FFF5F5",
  Hover: {
    boxShadow: "inset 0 0 0 1px #AB2123",
    backgroundColor: "#FFF5F5",
  },

  // Button Color
  ThemeBGColor: "#AB2123",
  LightThemeBGColor: "#FFF5F5",
  PrimaryButtonBGColor: "#AB2123",
  PrimaryButtonHoverBGColor: "#891A1C",
  PrimaryButtonTextColor: "#FFFFFF",

  SecondaryButtonBGcolor: "#FFF5F5",
  SecondaryButtonHoverBGColor: "#E9EBEB",
  SecondaryButtonTextColor: "#AB2123",
  SecondaryButtonBorderColor: "#AB2123",

  NeutralButtonBGColor: "#F2F3F3",
  NeutralButtonHoverBGColor: "#E9EBEB",
  NeutralButtonTextColor: "#0F1114",

  // Table Colors
  TableHeadingBGColor: "#FFF5F5",

  // Colors
  LightGrayColor: "#F2F3F3",
  LightGrayColorHover: "#F7F8F8",
  PageBackgroundColor: "#e9ecef",
};
